// The manifest itself — the one place the five row groups compose.
// Split out of `../capability-manifest.ts`, which is now the barrel over this
// directory.

import { ACCESS_CAPABILITIES } from './rows-access';
import { COMMERCE_CAPABILITIES } from './rows-commerce';
import { DELIVERY_CAPABILITIES } from './rows-delivery';
import { OPS_CAPABILITIES } from './rows-ops';
import { WORK_CAPABILITIES } from './rows-work';
import type { Capability } from './surface';

/**
 * Every capability the platform serves, on any surface: `capabilityId →
 * {rest, mcp, ui}`, grouped by resource.
 *
 * Checked against the real catalogs by `capability-manifest.test.ts`: every
 * `REST_ROUTES` id, every `ARMY_ACTION_SCOPES` action and every `FLAT_TOOL_SCOPES`
 * tool has a row that claims it, and nothing is claimed that does not exist.
 */
export const CAPABILITY_MANIFEST: Readonly<Record<string, Capability>> = {
  ...ACCESS_CAPABILITIES,
  ...WORK_CAPABILITIES,
  ...DELIVERY_CAPABILITIES,
  ...COMMERCE_CAPABILITIES,
  ...OPS_CAPABILITIES,
};
